export const STATUS_FILTER_ENABLED = 'STATUS_FILTER_ENABLED'
export const STATUS_FILTER_DISABLED = 'STATUS_FILTER_DISABLED'

function enable(statusFilter) {
  return {
    type: STATUS_FILTER_ENABLED,
    statusFilter,
  }
}

function disable() {
  return {
    type: STATUS_FILTER_DISABLED,
    statusFilter: null,
  }
}

export function enableStatusFilter(filter) {
  return (dispatch) => {
    dispatch(enable(filter))
  }
}

export function disableStatusFilter() {
  return (dispatch) => {
    dispatch(disable())
  }
}
